import { render } from "./view.vue?vue&type=template&id=0aa0ea2b&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"

import "./view.vue?vue&type=style&index=0&id=0aa0ea2b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0aa0ea2b"

export default script